import { delay } from 'redux-saga';
import { call, fork, cancel, cancelled, take, select, put } from 'redux-saga/effects';

import * as api from 'api';
import * as actions from 'actions';
import { getAuth } from 'selectors';
import { navigateToWebsite } from 'utils/sagas';
import { isTokenValid, removeAuthData } from 'authStore';

export function *manageToken(socket) {
  const refreshTask = yield fork(refreshTokenPeriodically, socket);

  while(true) { // eslint-disable-line no-constant-condition
    const action = yield take('*');
    const auth = yield select(getAuth);

    if(!isTokenValid(auth) || (action.error && action.error.httpResponse && action.error.httpResponse.status === 401)) {
      yield cancel(refreshTask);
      break;
    }
  }

  yield call(navigateToWebsite);
}

export function* refreshTokenPeriodically(socket) {
  while(true) { // eslint-disable-line no-constant-condition
    try {
      const authData = yield call(api.authTokenRefresh);

      yield call([socket, socket.refreshToken], authData.accessToken);
      yield put(actions.authUpdate(authData));
    }
    catch(error) {
      if(yield cancelled()) {
        return;
      }
      else {
        error.showInInfoBar = false;
        yield put({type: 'REFRESH_TOKEN_ERROR', error, errorMessage: 'Could not refresh token.'});
      }
    }

    yield call(delay, process.env.KOOTH_TOKEN_REFRESH_INTERVAL);
  }
}

export function* watchForLogout() {
  while(true) { // eslint-disable-line no-constant-condition
    yield take(actions.AUTH_LOGOUT);

    yield call(removeAuthData);
    yield call(navigateToWebsite);
  }
}

export default function* backgroundSaga(socket) {
  yield [
    fork(manageToken, socket),
    fork(watchForLogout)
  ];
}



/** WEBPACK FOOTER **
 ** ./src/members/state/auth/sagas.js
 **/